import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

import { useGetLivestreamingCardsQuery } from '../../redux/apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody } from '../other/card/card';
import generateLivestreamingStats from './data/livestreamingStatsCards';
import getChartOptions from '../IPTVAnalytics/charts/statsOptions';

const LiveStreamingStatsCards = () => {
  const { data, isLoading, isError, error } = useGetLivestreamingCardsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [chartOptions, setChartOptions] = useState(getChartOptions());

  useEffect(() => {
    const onThemeReload = () => setChartOptions(getChartOptions());
    document.addEventListener('theme-reload', onThemeReload);
    return () => document.removeEventListener('theme-reload', onThemeReload);
  }, []);

  const stats = generateLivestreamingStats(data);

  return (
    <div className='row g-2'>
      {stats.map(stat => (
        <div className='col-12 col-md-6 col-xl-3' key={stat.title}>
          <Card className='mb-0 h-100'>
            <CardBody className='relative p-0'>
              {isLoading ? <ComponentLoader /> : null}
              {isError ? (
                <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                  Failed to load.
                  {error?.data?.message ? ` ${error.data.message}` : ''}
                </div>
              ) : null}
              <div className='p-4 h-100 d-flex flex-column'>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1'>{stat.title}</span>
                </div>
                <div className='row align-items-center mb-0'>
                  <div className='col-6'>
                    <h4 className='mb-0'>{stat.total}</h4>
                  </div>
                  <div className='col-6 d-flex justify-end'>
                    <div className='mt-n3'>
                      <Chart
                        type={stat?.chartType}
                        height={40}
                        options={chartOptions[stat?.chartType]}
                        series={stat?.chartData}
                      />
                    </div>
                  </div>
                </div>
                <div className='small text-inverse text-opacity-50 text-truncate mt-2'>{stat.subtitle}</div>
              </div>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default LiveStreamingStatsCards;
